import { useLocation, useNavigate } from 'react-router-dom'
import { useRouteSession } from '@web/app'
import { ROUTES } from '@web/router'
import { VerifyEmailScreen } from '@web/screens/auth/email-code/verify-email'

function useVerify(search: string, pathname: string) {
	const navigate = useNavigate()
	const params = new URLSearchParams(search)
	const email = params.get('email') ?? ''
	const redirectTo = params.get('redirect') ?? ROUTES.getStarted
	const setEmail = (address: string) => {
		const next = new URLSearchParams(search)
		next.set('email', address)
		void navigate(`${pathname}?${next.toString()}`, { replace: true })
	}
	return { email, redirectTo, setEmail, navigate }
}

export function SignInVerify() {
	const { search, pathname } = useLocation()
	const { state } = useRouteSession()
	const { email, redirectTo, setEmail, navigate } = useVerify(search, pathname)

	return (
		<VerifyEmailScreen
			backTo={ROUTES.signIn}
			email={email}
			error={state.status === 'anonymous' ? state.error : null}
			kind="sign-in"
			navigate={navigate}
			onEmail={setEmail}
			redirectTo={redirectTo}
		/>
	)
}

export function SignUpVerify() {
	const { search, pathname } = useLocation()
	const { state } = useRouteSession()
	const { email, redirectTo, setEmail, navigate } = useVerify(search, pathname)

	return (
		<VerifyEmailScreen
			backTo={ROUTES.signUp}
			email={email}
			error={state.status === 'anonymous' ? state.error : null}
			kind="sign-up"
			navigate={navigate}
			onEmail={setEmail}
			redirectTo={redirectTo}
		/>
	)
}
